// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/container-" + chunkId + "-" + "6f2043ae1b604bbfb04c" + "-3asgoih.chunk.css";
};